import styles from "./featured.module.css";
import { Border } from '../maincomps/border/Border';
import { useNavigate } from 'react-router-dom';
import { useCurrency } from '../../context/CurrencyContext';


const Featured = ({ featurerdproducts }) => {

  const navigate = useNavigate();
  const { formatPrice } = useCurrency();

  return (
    <>
      <Border title='Featured Products' subtitle='Find all the trending products' />
      <div className={styles.container}>
        <div className={styles.sectioncontainer}>
          <div className={styles.grid}>
            {featurerdproducts?.map((item, index) => {
              const basePrice = item?.pricing?.finalSalePrice?.value;
              const discountPercentage = item?.discount?.discountValue
              const finalPrice = basePrice - (basePrice * discountPercentage / 100)
              return (

                <div className={styles.item} key={index}
                  onClick={() => {
                    navigate(`/prodDescription/${item?._id}`)
                    window.scrollTo(0, 0);
                  }}
                >

                  <div className={styles.imagecover}>
                    <img
                      src={item.featurerdImage}
                      alt='FeaturedImage'
                      className={styles.image}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                  <p className={styles.name}>{item.productName}</p>
                  <div className={styles.prices}>
                    <p className={styles.finalprice}>{formatPrice(item?.sellingPrice)}</p>
                    {discountPercentage === 0 ? (
                      null
                    ) : (
                      <p className={styles.actualprice}>{formatPrice(item?.totalPrice)}</p>
                    )}
                  </div>
                </div>
              )
            }
            )}
          </div>
          <div className={styles.seeMoreButton} onClick={() => {
            navigate(`/product/${featurerdproducts[0]?.category?.productCategory}`, { state: "Gold" })
            window.scrollTo(0, 0);
          }
          }>
            Show more
          </div>
        </div>
      </div>
    </>
  );
};

export default Featured;
